import React from "react";
import PreviousResultCard from "./PreviousResultCard";

function PreviousWinsSection({ results }) {
  const resultElements = results.map((result) => (
    <PreviousResultCard result={result} key={result._id} />
  ));

  return (
    <section className="previous_results_section">
      <h2>Recent Expert Results</h2>
      <div className="previous_results_container">{resultElements}</div>
    </section>
  );
}

export default PreviousWinsSection;
